import { DataBean } from "../DataBean";

export class CreateMoney extends DataBean {


    public async createMoneyBaseForCashDeskAccount(idCashDeskAccount:any,idCashDeskAccountCDP:any,observations:any,accountantDate:any,idEmployee): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "com.quickdataerp.bean.accountant.AccountantDocument_createMoneyBaseForCashDeskAccount_Number_Number_String_java.util.Date_Number", [idCashDeskAccount,idCashDeskAccountCDP ,observations,accountantDate,idEmployee]);
    }

}